<template>
  <div class="productPrice">
    <div v-if="priceBeforeDiscount" class="productPrice__previous">
      <span class="productPrice__discount"
        >-{{
          $helper.calculateDiscount(
            showNetPrices ? priceBeforeDiscount.net : priceBeforeDiscount.gross,
            showNetPrices ? priceDisplay.net : priceDisplay.gross,
          )
        }}%</span
      >

      <span class="productPrice__previousNumber productPrice__previousNumber--line">
        {{ priceBeforeDiscount.currencyPrefix
        }}{{
          showNetPrices ? priceBeforeDiscount.netFormatted : priceBeforeDiscount.grossFormatted
        }}
        {{ priceDisplay.currencyPostfix }}
      </span>
    </div>

    <div class="productPrice__main">
      <span class="productPrice__mainNumber">
        {{ priceDisplay.currencyPrefix
        }}{{ showNetPrices ? priceDisplay.netFormatted : priceDisplay.grossFormatted }}
      </span>
      {{ priceDisplay.currencyPostfix }} {{ showNetPrices ? $t('net') : $t('gross') }}
    </div>
    <div class="productPrice__mainUnit" v-if="unitPrice && unitPrice.net !== priceDisplay.net">
      <span class="productPrice__mainUnitDiscount" v-if="unitDiscount">{{ unitDiscount }}%</span
      ><span class="productPrice__mainUnitPrice"
        >{{ unitPrice.currencyPrefix
        }}{{ showNetPrices ? unitPrice.netFormatted : unitPrice.grossFormatted }}
        {{ priceDisplay.currencyPostfix }}/{{ uom }}</span
      >
    </div>
    <div v-if="pricePerBaseUom?.net" class="productPrice__priceUom">
      {{ showNetPrices ? pricePerBaseUom.net : pricePerBaseUom.gross }}
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  name: 'ProductPrice',
  props: {
    priceDisplay: {
      type: Object,
      default: null,
    },
    priceBeforeDiscount: {
      type: Object,
      default: null,
    },
    unitPrice: {
      type: Object,
      default: null,
    },
    unitDiscount: {
      type: Number,
      default: null,
    },
    uom: {
      type: String,
      default: '',
    },
    pricePerBaseUom: {
      type: Object,
      default: null,
    },
  },
  computed: {
    ...mapGetters('auth', ['showNetPrices']),
  },
};
</script>

<style lang="scss">
.productPrice {
  font-family: $fSecond;

  &__main {
    font-size: 1.6rem;
    line-height: 2.2rem;
  }

  &__mainNumber {
    font-size: 2.2rem;
    line-height: 2.2rem;
    font-weight: 500;
  }

  &__previous {
    position: relative;
    display: inline-flex;
    margin-bottom: 0.7rem;
    align-items: center;
    font-size: 1.6rem;
    line-height: 2.2rem;
    color: $cAddDark02;
    z-index: 2;
  }

  &__previousNumber {
    &--line {
      padding-right: 0.7rem;
      text-decoration: line-through;
    }
  }

  &__previousInfo {
    position: relative;
    top: -1.3rem;
    padding: 0.3rem 1.1rem;
    max-width: 23.5rem;
    background-color: $cDarkGrey;
    box-shadow: 0 2rem 1.5rem rgba($cMainDark, 0.16);
    border-radius: 0.5rem;
    font-size: 1.3rem;
    line-height: 2.4rem;
    color: $cWhite;
    z-index: $zPopup;

    @include rwd('ultra') {
      max-width: 16rem;
    }

    &:after {
      content: '';
      position: absolute;
      bottom: -0.8rem;
      left: 50%;
      width: 0;
      height: 0;
      border-left: 0.9rem solid transparent;
      border-right: 0.9rem solid transparent;
      border-bottom: 0.8rem solid $cDarkGrey;
      transform: translateX(-50%) rotate(180deg);
    }

    &--mobile {
      top: initial;
      max-width: 18rem;
      left: 2rem;

      &:after {
        bottom: initial;
        left: -1.3rem;
        top: 50%;
        transform: translateY(-50%) rotate(-90deg);
      }
    }
  }

  &__discount {
    font-size: 1.2rem;
    font-weight: 700;
    line-height: 1.5rem;
    height: 1.9rem;
    background-color: $cBadgeProm;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    color: $cWhite;
    margin-right: 0.6rem;
    padding: 1px 0.6rem 0;
  }

  &__mainUnit {
    margin-top: 0.4rem;
  }

  &__mainUnitPrice {
    font-size: 1.2rem;
  }

  &__mainUnitDiscount {
    background-color: $cBadgeProm;
    color: $cWhite;
    padding: 0.1rem 0.4rem;
    border-radius: 0.2rem;
    font-weight: 700;
    font-size: 1.2rem;
    margin-right: 0.5rem;
  }

  &__priceUom {
    font-size: 1.1rem;
    color: $cMainNeutral;
  }
}
</style>
